import script from "./NavbarButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarButtons.vue?vue&type=script&setup=true&lang=js"

import "./NavbarButtons.vue?vue&type=style&index=0&id=42b46ab0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42b46ab0"]])

export default __exports__